import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, HostBinding, InjectionToken, isDevMode, PLATFORM_ID, Component, ViewEncapsulation, ChangeDetectionStrategy, Inject, ViewChild, ContentChild, ContentChildren, Optional, Host, Self, HostListener, Injectable, NgModule } from '@angular/core';
import * as i1$3 from '@geneplanet/ngx-ui/src/lib/shared';
import { coerceBooleanProperty, Errors, KeyCodes, isErrorState, GpuSharedModule } from '@geneplanet/ngx-ui/src/lib/shared';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Subject, concat, merge, fromEvent } from 'rxjs';
import * as i1 from '@angular/common';
import { isPlatformServer, isPlatformBrowser, DOCUMENT, getLocaleNumberSymbol, NumberSymbol, CommonModule } from '@angular/common';
import * as i2 from '@angular/cdk/observers';
import { ObserversModule } from '@angular/cdk/observers';
import { tap, debounceTime, filter, map, startWith, delay, takeUntil } from 'rxjs/operators';
import * as i1$1 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import * as i2$1 from '@angular/forms';
import * as i1$2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

class GpuFormFieldControl {
}

class GpuPrefixDirective {
    constructor() {
        this.filledChanged = new EventEmitter();
        this.disabledChanged = new EventEmitter();
        this.clicked = new EventEmitter();
        this.isFilled = false;
        this.isDisabled = false;
    }
    get filled() {
        return this.isFilled;
    }
    set filled(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue !== this.isFilled) {
            this.isFilled = coercedValue;
            this.filledChanged.emit(this.isFilled);
        }
    }
    get disabled() {
        return this.isDisabled;
    }
    set disabled(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue !== this.isDisabled) {
            this.isDisabled = coercedValue;
            this.disabledChanged.emit(this.isDisabled);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuPrefixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuPrefixDirective, selector: "[gpuPrefix]", inputs: { filled: "filled", disabled: "disabled" }, outputs: { filledChanged: "filledChanged", disabledChanged: "disabledChanged", clicked: "clicked" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuPrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[gpuPrefix]',
                }]
        }], propDecorators: { filled: [{
                type: Input
            }], disabled: [{
                type: Input
            }], filledChanged: [{
                type: Output
            }], disabledChanged: [{
                type: Output
            }], clicked: [{
                type: Output
            }] } });

class GpuSuffixDirective {
    constructor() {
        this.stopPropagation = false;
        this.filledChanged = new EventEmitter();
        this.disabledChanged = new EventEmitter();
        this.clicked = new EventEmitter();
        this.isFilled = false;
        this.isDisabled = false;
    }
    get filled() {
        return this.isFilled;
    }
    set filled(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue !== this.isFilled) {
            this.isFilled = coercedValue;
            this.filledChanged.emit(this.isFilled);
        }
    }
    get disabled() {
        return this.isDisabled;
    }
    set disabled(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue !== this.isDisabled) {
            this.isDisabled = coercedValue;
            this.disabledChanged.emit(this.isDisabled);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuSuffixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuSuffixDirective, selector: "[gpuSuffix]", inputs: { filled: "filled", disabled: "disabled", stopPropagation: "stopPropagation" }, outputs: { filledChanged: "filledChanged", disabledChanged: "disabledChanged", clicked: "clicked" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[gpuSuffix]',
                }]
        }], propDecorators: { filled: [{
                type: Input
            }], disabled: [{
                type: Input
            }], stopPropagation: [{
                type: Input
            }], filledChanged: [{
                type: Output
            }], disabledChanged: [{
                type: Output
            }], clicked: [{
                type: Output
            }] } });

class GpuLabelDirective {
    constructor() {
        this.labelClass = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuLabelDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuLabelDirective, selector: "gpu-label", host: { properties: { "class.gpu-label": "this.labelClass" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'gpu-label',
                }]
        }], propDecorators: { labelClass: [{
                type: HostBinding,
                args: ['class.gpu-label']
            }] } });

class GpuErrorDirective {
    constructor() {
        this.errorClass = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuErrorDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuErrorDirective, selector: "gpu-error", host: { properties: { "class.gpu-error": "this.errorClass" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuErrorDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'gpu-error',
                }]
        }], propDecorators: { errorClass: [{
                type: HostBinding,
                args: ['class.gpu-error']
            }] } });

class GpuHintDirective {
    constructor() {
        this.hintClass = true;
        this.static = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuHintDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuHintDirective, selector: "gpu-hint", inputs: { static: "static" }, host: { properties: { "class.gpu-hint": "this.hintClass" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuHintDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'gpu-hint',
                }]
        }], propDecorators: { hintClass: [{
                type: HostBinding,
                args: ['class.gpu-hint']
            }], static: [{
                type: Input
            }] } });

const GPU_FORM_FIELD = new InjectionToken('GpuFormField');
const GPU_SELECT_TRIGGER = new InjectionToken('GpuSelectTrigger');
const MAX_PANEL_HEIGHT = 256;
const FLOATING_LABEL_SCALE = 0.75;
const OUTLINE_GAP_PADDING = 4;
const INPUT_AUTOFILLED_CLASS = 'gpu-input-autofilled';
const INPUT_AUTOFILL_START_CLASS = 'gpu-input-autofill-start';
const INPUT_AUTOFILL_END_CLASS = 'gpu-input-autofill-end';

var GpuFormFieldAppearance;
(function (GpuFormFieldAppearance) {
    GpuFormFieldAppearance["Outline"] = "outline";
    GpuFormFieldAppearance["Card"] = "card";
})(GpuFormFieldAppearance || (GpuFormFieldAppearance = {}));

var GpuFormFieldMessageType;
(function (GpuFormFieldMessageType) {
    GpuFormFieldMessageType["Error"] = "error";
    GpuFormFieldMessageType["Hint"] = "hint";
})(GpuFormFieldMessageType || (GpuFormFieldMessageType = {}));

var GpuFormControlType;
(function (GpuFormControlType) {
    GpuFormControlType["Input"] = "input";
    GpuFormControlType["Select"] = "select";
    GpuFormControlType["FilterableSelect"] = "filterable-select";
    GpuFormControlType["Datepicker"] = "datepicker";
})(GpuFormControlType || (GpuFormControlType = {}));

class GpuPreSuffixDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuPreSuffixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuPreSuffixDirective, selector: "[gpuPreSuffix]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuPreSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[gpuPreSuffix]',
                }]
        }] });

var GpuFormFieldSize;
(function (GpuFormFieldSize) {
    GpuFormFieldSize["Normal"] = "normal";
    GpuFormFieldSize["Small"] = "small";
})(GpuFormFieldSize || (GpuFormFieldSize = {}));

let GpuFormFieldComponent = class GpuFormFieldComponent {
    get size() {
        return this._size;
    }
    set size(size) {
        if (size !== this._size) {
            this._size = size;
            this.sizeChange.next();
            setTimeout(() => this.updateOutline());
        }
    }
    get backgroundColor() {
        return this.backgroundColorValue;
    }
    set backgroundColor(color) {
        this.backgroundColorValue = color;
        this.formFieldControl?.updateBoxShadowColor?.(color);
    }
    constructor(changeDetectorRef, platformId) {
        this.changeDetectorRef = changeDetectorRef;
        this.platformId = platformId;
        this.formFieldClass = true;
        this.isSsrClass = isPlatformServer(this.platformId);
        this.appearance = GpuFormFieldAppearance.Outline;
        this.containerClicked = new EventEmitter();
        this.formFieldAppearance = GpuFormFieldAppearance;
        this.formFieldSize = GpuFormFieldSize;
        this.formFieldMessageType = GpuFormFieldMessageType;
        this.sizeChange = new Subject();
        this.backgroundColorValue = 'white';
        this._size = GpuFormFieldSize.Normal;
    }
    ngAfterViewInit() {
        if (!this.formFieldControl && isDevMode()) {
            return Errors.missingFormFieldControlException();
        }
        this.updateOutline();
        this.formFieldControl?.updateBoxShadowColor?.(this.backgroundColor);
        concat(this.prefixRef?.filledChanged ?? [], this.suffixRef?.filledChanged ?? [])
            .pipe(untilDestroyed(this))
            .subscribe(() => {
            this.changeDetectorRef.markForCheck();
            setTimeout(() => this.updateOutline());
        });
        concat(this.prefixRef?.disabledChanged ?? [], this.suffixRef?.disabledChanged ?? [])
            .pipe(untilDestroyed(this))
            .subscribe(() => this.changeDetectorRef.markForCheck());
        concat(this.formFieldControl?.stateChanges ?? [], this.formFieldControl?.control?.valueChanges ?? [])
            .pipe(untilDestroyed(this))
            .subscribe(() => this.changeDetectorRef.markForCheck());
        this.changeDetectorRef.detectChanges();
    }
    prefixClick() {
        if (this.prefixRef && !this.prefixRef.disabled) {
            this.prefixRef.clicked.emit();
        }
    }
    suffixClick(event) {
        if (this.suffixRef?.stopPropagation) {
            event.stopPropagation();
        }
        if (this.suffixRef && !this.suffixRef.disabled) {
            this.suffixRef.clicked.emit();
        }
        else if (this.showClearSuffix()) {
            this.formFieldControl?.control?.setValue('');
        }
    }
    getMessageType() {
        if (this.formFieldControl?.errorState && this.errorChildren?.length > 0) {
            return GpuFormFieldMessageType.Error;
        }
        if (this.formFieldControl?.focused || this.hintChild?.static) {
            return GpuFormFieldMessageType.Hint;
        }
        return null;
    }
    getBorderColor() {
        return this.appearance === GpuFormFieldAppearance.Card ? this.backgroundColor : '';
    }
    hidePlaceholder() {
        return this.hasLabel() && !this.formFieldControl?.focused;
    }
    floatLabel() {
        return (this.hasLabel() &&
            (this.formFieldControl?.focused ||
                this.formFieldControl?.autofilled ||
                (this.formFieldControl?.value != null && this.formFieldControl?.value !== '') ||
                ((this.formFieldControl?.controlType === GpuFormControlType.Select ||
                    this.formFieldControl?.controlType === GpuFormControlType.FilterableSelect) &&
                    this.formFieldControl?.viewValue?.length > 0)));
    }
    hasLabel() {
        return !!this.labelRef;
    }
    showClearSuffix() {
        return (!this.suffixRef &&
            this.formFieldControl?.controlType === GpuFormControlType.Input &&
            this.formFieldControl?.errorState &&
            this.formFieldControl?.value?.length > 0);
    }
    updateOutline() {
        let startWidth = 12;
        let gapWidth = 0;
        const container = this.containerEltRef.nativeElement;
        const label = this.labelEltRef.nativeElement;
        if (this.labelRef && label.children.length && isPlatformBrowser(this.platformId)) {
            const labelChildren = label.children;
            let labelWidth = 0;
            for (let i = 0; i < labelChildren.length; i++) {
                labelWidth += labelChildren[i].offsetWidth;
            }
            startWidth =
                Math.abs(label.getBoundingClientRect().left - container.getBoundingClientRect().left) - OUTLINE_GAP_PADDING;
            gapWidth = labelWidth > 0 ? labelWidth * FLOATING_LABEL_SCALE + OUTLINE_GAP_PADDING * 2 : 0;
        }
        container.querySelector('.gpu-form-field-outline-start').style.width = `${startWidth}px`;
        // 80% is the limit of how long label can be (it's truncated).
        // 24px is width of both corners.
        container.querySelector('.gpu-form-field-outline-gap').style.width = `min(calc(80% - 24px), ${gapWidth + 4}px)`;
    }
    onContainerClick(event) {
        if (this.formFieldControl?.onContainerClick) {
            this.formFieldControl?.onContainerClick(event);
        }
        this.containerClicked.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuFormFieldComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: GpuFormFieldComponent, selector: "gpu-form-field", inputs: { appearance: "appearance", size: "size", backgroundColor: "backgroundColor" }, outputs: { containerClicked: "containerClicked" }, host: { properties: { "class.gpu-form-field": "this.formFieldClass", "class.gpu-is-ssr": "this.isSsrClass" } }, providers: [{ provide: GPU_FORM_FIELD, useExisting: GpuFormFieldComponent }], queries: [{ propertyName: "prefixRef", first: true, predicate: GpuPrefixDirective, descendants: true }, { propertyName: "formFieldControl", first: true, predicate: GpuFormFieldControl, descendants: true }, { propertyName: "labelRef", first: true, predicate: GpuLabelDirective, descendants: true }, { propertyName: "preSuffixRef", first: true, predicate: GpuPreSuffixDirective, descendants: true }, { propertyName: "suffixRef", first: true, predicate: GpuSuffixDirective, descendants: true }, { propertyName: "hintChild", first: true, predicate: GpuHintDirective, descendants: true }, { propertyName: "errorChildren", predicate: GpuErrorDirective, descendants: true }], viewQueries: [{ propertyName: "containerEltRef", first: true, predicate: ["container"], descendants: true, static: true }, { propertyName: "inputContainerEltRef", first: true, predicate: ["inputContainer"], descendants: true }, { propertyName: "labelEltRef", first: true, predicate: ["label"], descendants: true }], ngImport: i0, template: "<div\n  class=\"gpu-form-field-wrapper\"\n  [class.gpu-form-field-appearance-outline]=\"appearance == formFieldAppearance.Outline\"\n  [class.gpu-form-field-appearance-card]=\"appearance == formFieldAppearance.Card\"\n  [class.gpu-form-field-size-small]=\"size == formFieldSize.Small\"\n  [class.gpu-form-field-hide-placeholder]=\"hidePlaceholder()\"\n  [class.gpu-form-field-has-label]=\"hasLabel()\"\n  [class.gpu-form-field-float-label]=\"floatLabel()\"\n  [class.gpu-focused]=\"formFieldControl?.focused\"\n  [class.gpu-invalid]=\"formFieldControl?.errorState\"\n  [class.gpu-disabled]=\"formFieldControl?.disabled\"\n  [class.gpu-readonly]=\"formFieldControl?.readonly\"\n  [ngClass]=\"formFieldControl?.controlType ? 'gpu-form-field-type-' + formFieldControl?.controlType : ''\"\n>\n  <div\n    class=\"gpu-form-field-flex\"\n    #container\n    (click)=\"onContainerClick($event)\"\n    [style.backgroundColor]=\"backgroundColor\"\n  >\n    <div class=\"gpu-form-field-outline\">\n      <div class=\"gpu-form-field-outline-start\" [style.borderColor]=\"getBorderColor()\"></div>\n      <div class=\"gpu-form-field-outline-gap\" [style.borderColor]=\"getBorderColor()\"></div>\n      <div class=\"gpu-form-field-outline-end\" [style.borderColor]=\"getBorderColor()\"></div>\n    </div>\n\n    <div\n      class=\"gpu-form-field-prefix\"\n      [class.gpu-filled-prefix]=\"prefixRef?.filled\"\n      [class.gpu-disabled-prefix]=\"prefixRef?.disabled\"\n      *ngIf=\"prefixRef\"\n      (click)=\"prefixClick()\"\n    >\n      <ng-content select=\"[gpuPrefix]\"></ng-content>\n    </div>\n\n    <div\n      class=\"gpu-form-field-infix\"\n      [class.i1-regular]=\"size === formFieldSize.Normal\"\n      [class.p4-regular]=\"size === formFieldSize.Small\"\n      #inputContainer\n    >\n      <ng-content></ng-content>\n\n      <span class=\"gpu-form-field-label-wrapper\">\n        <label\n          class=\"gpu-form-field-label\"\n          #label\n          (cdkObserveContent)=\"updateOutline()\"\n          [cdkObserveContentDisabled]=\"appearance != formFieldAppearance.Outline\"\n        >\n          <ng-content select=\"gpu-label\"></ng-content>\n        </label>\n      </span>\n    </div>\n\n    <div *ngIf=\"preSuffixRef && suffixRef\" class=\"gpu-form-field-pre-suffix\">\n      <ng-content select=\"[gpuPreSuffix]\"></ng-content>\n    </div>\n\n    <div\n      class=\"gpu-form-field-suffix\"\n      [class.gpu-filled-suffix]=\"suffixRef?.filled\"\n      [class.gpu-disabled-suffix]=\"suffixRef?.disabled\"\n      [class.pointer]=\"showClearSuffix()\"\n      *ngIf=\"suffixRef || showClearSuffix()\"\n      (click)=\"suffixClick($event)\"\n    >\n      <ng-content *ngIf=\"suffixRef\" select=\"[gpuSuffix]\"></ng-content>\n      <i *ngIf=\"showClearSuffix()\" gpuSuffix class=\"gpicon-close\"></i>\n    </div>\n  </div>\n\n  <div class=\"gpu-form-field-message-wrapper i2-regular\" [ngSwitch]=\"getMessageType()\">\n    <ng-content *ngSwitchCase=\"formFieldMessageType.Error\" select=\"gpu-error\"></ng-content>\n    <ng-content *ngSwitchCase=\"formFieldMessageType.Hint\" select=\"gpu-hint\"></ng-content>\n  </div>\n</div>\n", styles: [".gpu-form-field{display:inline-block;width:100%;--infix-padding: .75rem;--border-radius: 12px}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small{--infix-padding: .375rem;--border-radius: 8px}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small .gpu-filterable-select .gpu-filterable-select-icon{right:-.75rem;top:.1rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small .gpu-select .gpu-select-wrapper .gpu-select-value,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small .gpu-filterable-select .gpu-filterable-select-wrapper .gpu-input{padding-right:1.5rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-has-label{margin-top:.5625rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-float-label .gpu-form-field-outline-gap{border-top-style:none}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-float-label .gpu-form-field-label{transform:translateY(calc((var(--infix-padding) + 1.125rem / 2) * -1)) scale(.75)}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-outline-end{border:1px solid #c7c7d2}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-label-wrapper{top:-.5625rem;padding-top:.5625rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-label{top:calc(var(--infix-padding) + 1.125rem / 2)}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card.gpu-form-field-has-label{margin-top:1.25rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card.gpu-form-field-float-label .gpu-form-field-label{transform:translateY(calc((var(--infix-padding) + 1.125rem + .125rem) * -1)) scale(.75)}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-outline-end{border:1px solid #ffffff}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-label-wrapper{top:-1.25rem;padding-top:1.25rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-label{top:calc(var(--infix-padding) + 1.125rem + .125rem)}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-select:not(.gpu-disabled):not(.gpu-readonly) .gpu-form-field-flex{cursor:pointer}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-select:not(.gpu-form-field-float-label) .gpu-form-field-label,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-filterable-select:not(.gpu-form-field-float-label) .gpu-form-field-label{right:2rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-datepicker:not(.gpu-disabled) .gpu-form-field-flex{cursor:pointer}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-datepicker:not(.gpu-disabled) .gpu-form-field-flex .gpu-datepicker{cursor:pointer}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-datepicker .gpu-form-field-flex{min-width:275px}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-datepicker ngb-datepicker{top:.625rem!important;left:-1rem!important;right:-3rem}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-outline-end{border:1px solid #9eadf9}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-label{color:#8fa1f8}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-flex{box-shadow:0 4px 10px #6a81f633}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-prefix,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-suffix,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-filterable-select .gpu-filterable-select-icon{color:#9eadf9}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-hint{color:#6a81f6}.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-outline-end{border:1px solid #ff7eab}.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-label{color:#ff6b9f}.gpu-form-field .gpu-form-field-wrapper.gpu-invalid.gpu-focused .gpu-form-field-flex{box-shadow:0 4px 10px #ff619933}.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-prefix,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-suffix,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-filterable-select .gpu-filterable-select-icon{color:#ff7eab}.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-form-field-label,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-input,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-input::placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-select .gpu-select-placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-filterable-select .gpu-filterable-select-icon{color:#9599aa;-webkit-text-fill-color:#9599aa;opacity:1}.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-form-field-flex{opacity:.65}.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-form-field-label,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-input,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-input::placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-select .gpu-select-placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-filterable-select .gpu-filterable-select-icon{color:#9599aa;-webkit-text-fill-color:#9599aa;opacity:1}.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-form-field-flex{opacity:.65}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-hide-placeholder .gpu-input::placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-hide-placeholder .gpu-select .gpu-placeholder{opacity:0}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-flex{display:inline-flex;align-items:stretch;position:relative;width:100%;padding:0 1rem;border-radius:var(--border-radius)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline{display:flex;position:absolute;top:0;right:0;bottom:0;left:0}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-end{height:100%}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-start{border-right-style:none;border-radius:var(--border-radius) 0 0 var(--border-radius)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-gap{border-left-style:none;border-right-style:none}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-end{flex-grow:1;border-left-style:none;border-radius:0 var(--border-radius) var(--border-radius) 0}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-infix{position:relative;flex:auto;padding:var(--infix-padding) 0;width:100px;max-width:100%}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-pre-suffix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix{display:flex;align-items:center;color:#9599aa;z-index:1}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix{padding:0 var(--infix-padding)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix{margin:1px 1px 1px calc(-1rem + 1px);border-radius:var(--border-radius) 0 0 var(--border-radius)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix.gpu-filled-prefix{margin-right:var(--infix-padding)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix{margin:1px calc(-1rem + 1px) 1px 1px;border-radius:0 var(--border-radius) var(--border-radius) 0}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix.gpu-filled-suffix{margin-left:var(--infix-padding)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix.gpu-filled-prefix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix.gpu-filled-suffix{background:#eceffe;color:#6a81f6;font-weight:600}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix.gpu-filled-prefix.gpu-disabled-prefix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix.gpu-filled-suffix.gpu-disabled-suffix{background:#f9f9fe;color:#c7c7d2}.gpu-form-field .gpu-form-field-wrapper .gpu-input{border:none;outline:none;width:100%;padding:0;background:transparent;color:#2c3355;caret-color:#6a81f6}.gpu-form-field .gpu-form-field-wrapper .gpu-input:-webkit-autofill:first-line{font-family:Open Sans,-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Ubuntu;color:#2c3355}.gpu-form-field .gpu-form-field-wrapper .gpu-input::placeholder,.gpu-form-field .gpu-form-field-wrapper .gpu-select .gpu-placeholder{color:#9599aa}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-label-wrapper{position:absolute;left:0;width:100%;height:100%;overflow:hidden;pointer-events:none;box-sizing:content-box}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-label{position:absolute;left:0;right:0;color:#9599aa;pointer-events:none;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),color .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-message-wrapper{padding:0 1rem}.gpu-form-field .gpu-form-field-wrapper .gpu-error,.gpu-form-field .gpu-form-field-wrapper .gpu-hint{display:block;margin-top:.5rem}.gpu-form-field .gpu-form-field-wrapper .gpu-error{color:#ff6b9f}.gpu-form-field .gpu-form-field-wrapper .gpu-hint{color:#616680}.gpu-form-field .gpu-form-field-wrapper .gpu-select .gpu-select-wrapper,.gpu-form-field .gpu-form-field-wrapper .gpu-filterable-select .gpu-filterable-select-wrapper{margin-top:calc(var(--infix-padding) * -1);margin-bottom:calc(var(--infix-padding) * -1);padding-top:var(--infix-padding);padding-bottom:var(--infix-padding)}.gpu-form-field.gpu-is-ssr .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-float-label .gpu-form-field-label-wrapper{margin-left:-4px}.gpu-form-field.gpu-is-ssr .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-float-label .gpu-label{background:#fff;padding-left:5px;padding-right:6px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i2.CdkObserveContent, selector: "[cdkObserveContent]", inputs: ["cdkObserveContentDisabled", "debounce"], outputs: ["cdkObserveContent"], exportAs: ["cdkObserveContent"] }, { kind: "directive", type: GpuSuffixDirective, selector: "[gpuSuffix]", inputs: ["filled", "disabled", "stopPropagation"], outputs: ["filledChanged", "disabledChanged", "clicked"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
GpuFormFieldComponent = __decorate([
    UntilDestroy()
], GpuFormFieldComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuFormFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'gpu-form-field', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, providers: [{ provide: GPU_FORM_FIELD, useExisting: GpuFormFieldComponent }], template: "<div\n  class=\"gpu-form-field-wrapper\"\n  [class.gpu-form-field-appearance-outline]=\"appearance == formFieldAppearance.Outline\"\n  [class.gpu-form-field-appearance-card]=\"appearance == formFieldAppearance.Card\"\n  [class.gpu-form-field-size-small]=\"size == formFieldSize.Small\"\n  [class.gpu-form-field-hide-placeholder]=\"hidePlaceholder()\"\n  [class.gpu-form-field-has-label]=\"hasLabel()\"\n  [class.gpu-form-field-float-label]=\"floatLabel()\"\n  [class.gpu-focused]=\"formFieldControl?.focused\"\n  [class.gpu-invalid]=\"formFieldControl?.errorState\"\n  [class.gpu-disabled]=\"formFieldControl?.disabled\"\n  [class.gpu-readonly]=\"formFieldControl?.readonly\"\n  [ngClass]=\"formFieldControl?.controlType ? 'gpu-form-field-type-' + formFieldControl?.controlType : ''\"\n>\n  <div\n    class=\"gpu-form-field-flex\"\n    #container\n    (click)=\"onContainerClick($event)\"\n    [style.backgroundColor]=\"backgroundColor\"\n  >\n    <div class=\"gpu-form-field-outline\">\n      <div class=\"gpu-form-field-outline-start\" [style.borderColor]=\"getBorderColor()\"></div>\n      <div class=\"gpu-form-field-outline-gap\" [style.borderColor]=\"getBorderColor()\"></div>\n      <div class=\"gpu-form-field-outline-end\" [style.borderColor]=\"getBorderColor()\"></div>\n    </div>\n\n    <div\n      class=\"gpu-form-field-prefix\"\n      [class.gpu-filled-prefix]=\"prefixRef?.filled\"\n      [class.gpu-disabled-prefix]=\"prefixRef?.disabled\"\n      *ngIf=\"prefixRef\"\n      (click)=\"prefixClick()\"\n    >\n      <ng-content select=\"[gpuPrefix]\"></ng-content>\n    </div>\n\n    <div\n      class=\"gpu-form-field-infix\"\n      [class.i1-regular]=\"size === formFieldSize.Normal\"\n      [class.p4-regular]=\"size === formFieldSize.Small\"\n      #inputContainer\n    >\n      <ng-content></ng-content>\n\n      <span class=\"gpu-form-field-label-wrapper\">\n        <label\n          class=\"gpu-form-field-label\"\n          #label\n          (cdkObserveContent)=\"updateOutline()\"\n          [cdkObserveContentDisabled]=\"appearance != formFieldAppearance.Outline\"\n        >\n          <ng-content select=\"gpu-label\"></ng-content>\n        </label>\n      </span>\n    </div>\n\n    <div *ngIf=\"preSuffixRef && suffixRef\" class=\"gpu-form-field-pre-suffix\">\n      <ng-content select=\"[gpuPreSuffix]\"></ng-content>\n    </div>\n\n    <div\n      class=\"gpu-form-field-suffix\"\n      [class.gpu-filled-suffix]=\"suffixRef?.filled\"\n      [class.gpu-disabled-suffix]=\"suffixRef?.disabled\"\n      [class.pointer]=\"showClearSuffix()\"\n      *ngIf=\"suffixRef || showClearSuffix()\"\n      (click)=\"suffixClick($event)\"\n    >\n      <ng-content *ngIf=\"suffixRef\" select=\"[gpuSuffix]\"></ng-content>\n      <i *ngIf=\"showClearSuffix()\" gpuSuffix class=\"gpicon-close\"></i>\n    </div>\n  </div>\n\n  <div class=\"gpu-form-field-message-wrapper i2-regular\" [ngSwitch]=\"getMessageType()\">\n    <ng-content *ngSwitchCase=\"formFieldMessageType.Error\" select=\"gpu-error\"></ng-content>\n    <ng-content *ngSwitchCase=\"formFieldMessageType.Hint\" select=\"gpu-hint\"></ng-content>\n  </div>\n</div>\n", styles: [".gpu-form-field{display:inline-block;width:100%;--infix-padding: .75rem;--border-radius: 12px}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small{--infix-padding: .375rem;--border-radius: 8px}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small .gpu-filterable-select .gpu-filterable-select-icon{right:-.75rem;top:.1rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small .gpu-select .gpu-select-wrapper .gpu-select-value,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-size-small .gpu-filterable-select .gpu-filterable-select-wrapper .gpu-input{padding-right:1.5rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-has-label{margin-top:.5625rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-float-label .gpu-form-field-outline-gap{border-top-style:none}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-float-label .gpu-form-field-label{transform:translateY(calc((var(--infix-padding) + 1.125rem / 2) * -1)) scale(.75)}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-outline-end{border:1px solid #c7c7d2}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-label-wrapper{top:-.5625rem;padding-top:.5625rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-outline .gpu-form-field-label{top:calc(var(--infix-padding) + 1.125rem / 2)}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card.gpu-form-field-has-label{margin-top:1.25rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card.gpu-form-field-float-label .gpu-form-field-label{transform:translateY(calc((var(--infix-padding) + 1.125rem + .125rem) * -1)) scale(.75)}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-outline-end{border:1px solid #ffffff}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-label-wrapper{top:-1.25rem;padding-top:1.25rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-appearance-card .gpu-form-field-label{top:calc(var(--infix-padding) + 1.125rem + .125rem)}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-select:not(.gpu-disabled):not(.gpu-readonly) .gpu-form-field-flex{cursor:pointer}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-select:not(.gpu-form-field-float-label) .gpu-form-field-label,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-filterable-select:not(.gpu-form-field-float-label) .gpu-form-field-label{right:2rem}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-datepicker:not(.gpu-disabled) .gpu-form-field-flex{cursor:pointer}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-datepicker:not(.gpu-disabled) .gpu-form-field-flex .gpu-datepicker{cursor:pointer}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-datepicker .gpu-form-field-flex{min-width:275px}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-type-datepicker ngb-datepicker{top:.625rem!important;left:-1rem!important;right:-3rem}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-outline-end{border:1px solid #9eadf9}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-label{color:#8fa1f8}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-flex{box-shadow:0 4px 10px #6a81f633}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-prefix,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-form-field-suffix,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-filterable-select .gpu-filterable-select-icon{color:#9eadf9}.gpu-form-field .gpu-form-field-wrapper.gpu-focused .gpu-hint{color:#6a81f6}.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-outline-end{border:1px solid #ff7eab}.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-label{color:#ff6b9f}.gpu-form-field .gpu-form-field-wrapper.gpu-invalid.gpu-focused .gpu-form-field-flex{box-shadow:0 4px 10px #ff619933}.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-prefix,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-form-field-suffix,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-invalid .gpu-filterable-select .gpu-filterable-select-icon{color:#ff7eab}.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-form-field-label,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-input,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-input::placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-select .gpu-select-placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-filterable-select .gpu-filterable-select-icon{color:#9599aa;-webkit-text-fill-color:#9599aa;opacity:1}.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-outline .gpu-form-field-flex{opacity:.65}.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-form-field-label,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-input,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-input::placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-select .gpu-select-placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-select .gpu-select-icon,.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-filterable-select .gpu-filterable-select-icon{color:#9599aa;-webkit-text-fill-color:#9599aa;opacity:1}.gpu-form-field .gpu-form-field-wrapper.gpu-disabled.gpu-form-field-appearance-card .gpu-form-field-flex{opacity:.65}.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-hide-placeholder .gpu-input::placeholder,.gpu-form-field .gpu-form-field-wrapper.gpu-form-field-hide-placeholder .gpu-select .gpu-placeholder{opacity:0}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-flex{display:inline-flex;align-items:stretch;position:relative;width:100%;padding:0 1rem;border-radius:var(--border-radius)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline{display:flex;position:absolute;top:0;right:0;bottom:0;left:0}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-start,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-gap,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-end{height:100%}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-start{border-right-style:none;border-radius:var(--border-radius) 0 0 var(--border-radius)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-gap{border-left-style:none;border-right-style:none}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-outline .gpu-form-field-outline-end{flex-grow:1;border-left-style:none;border-radius:0 var(--border-radius) var(--border-radius) 0}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-infix{position:relative;flex:auto;padding:var(--infix-padding) 0;width:100px;max-width:100%}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-pre-suffix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix{display:flex;align-items:center;color:#9599aa;z-index:1}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix{padding:0 var(--infix-padding)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix{margin:1px 1px 1px calc(-1rem + 1px);border-radius:var(--border-radius) 0 0 var(--border-radius)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix.gpu-filled-prefix{margin-right:var(--infix-padding)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix{margin:1px calc(-1rem + 1px) 1px 1px;border-radius:0 var(--border-radius) var(--border-radius) 0}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix.gpu-filled-suffix{margin-left:var(--infix-padding)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix.gpu-filled-prefix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix.gpu-filled-suffix{background:#eceffe;color:#6a81f6;font-weight:600}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-prefix.gpu-filled-prefix.gpu-disabled-prefix,.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-suffix.gpu-filled-suffix.gpu-disabled-suffix{background:#f9f9fe;color:#c7c7d2}.gpu-form-field .gpu-form-field-wrapper .gpu-input{border:none;outline:none;width:100%;padding:0;background:transparent;color:#2c3355;caret-color:#6a81f6}.gpu-form-field .gpu-form-field-wrapper .gpu-input:-webkit-autofill:first-line{font-family:Open Sans,-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Ubuntu;color:#2c3355}.gpu-form-field .gpu-form-field-wrapper .gpu-input::placeholder,.gpu-form-field .gpu-form-field-wrapper .gpu-select .gpu-placeholder{color:#9599aa}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-label-wrapper{position:absolute;left:0;width:100%;height:100%;overflow:hidden;pointer-events:none;box-sizing:content-box}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-label{position:absolute;left:0;right:0;color:#9599aa;pointer-events:none;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),color .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1)}.gpu-form-field .gpu-form-field-wrapper .gpu-form-field-message-wrapper{padding:0 1rem}.gpu-form-field .gpu-form-field-wrapper .gpu-error,.gpu-form-field .gpu-form-field-wrapper .gpu-hint{display:block;margin-top:.5rem}.gpu-form-field .gpu-form-field-wrapper .gpu-error{color:#ff6b9f}.gpu-form-field .gpu-form-field-wrapper .gpu-hint{color:#616680}.gpu-form-field .gpu-form-field-wrapper .gpu-select .gpu-select-wrapper,.gpu-form-field .gpu-form-field-wrapper .gpu-filterable-select .gpu-filterable-select-wrapper{margin-top:calc(var(--infix-padding) * -1);margin-bottom:calc(var(--infix-padding) * -1);padding-top:var(--infix-padding);padding-bottom:var(--infix-padding)}.gpu-form-field.gpu-is-ssr .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-float-label .gpu-form-field-label-wrapper{margin-left:-4px}.gpu-form-field.gpu-is-ssr .gpu-form-field-wrapper.gpu-form-field-appearance-outline.gpu-form-field-float-label .gpu-label{background:#fff;padding-left:5px;padding-right:6px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }], propDecorators: { formFieldClass: [{
                type: HostBinding,
                args: ['class.gpu-form-field']
            }], isSsrClass: [{
                type: HostBinding,
                args: ['class.gpu-is-ssr']
            }], appearance: [{
                type: Input
            }], size: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], containerClicked: [{
                type: Output
            }], containerEltRef: [{
                type: ViewChild,
                args: ['container', { static: true }]
            }], inputContainerEltRef: [{
                type: ViewChild,
                args: ['inputContainer']
            }], prefixRef: [{
                type: ContentChild,
                args: [GpuPrefixDirective]
            }], formFieldControl: [{
                type: ContentChild,
                args: [GpuFormFieldControl]
            }], labelRef: [{
                type: ContentChild,
                args: [GpuLabelDirective]
            }], preSuffixRef: [{
                type: ContentChild,
                args: [GpuPreSuffixDirective]
            }], suffixRef: [{
                type: ContentChild,
                args: [GpuSuffixDirective]
            }], errorChildren: [{
                type: ContentChildren,
                args: [GpuErrorDirective, { descendants: true }]
            }], hintChild: [{
                type: ContentChild,
                args: [GpuHintDirective]
            }], labelEltRef: [{
                type: ViewChild,
                args: ['label']
            }] } });

class KeyManager {
    constructor(optionsList) {
        this.optionsList = optionsList;
        this.change = new Subject();
        this.tabOut = new Subject();
        this.activeOptionIndex = -1;
        this.letterKeyStream = new Subject();
        this.pressedLetters = [];
        this.options = this.optionsList.toArray();
        this.optionsListSubscription = optionsList.changes.subscribe((newOptions) => {
            this.options = newOptions.toArray();
            if (this.activeOption) {
                const newIndex = this.options.indexOf(this.activeOption);
                if (newIndex > -1 && newIndex !== this.activeOptionIndex) {
                    this.activeOptionIndex = newIndex;
                }
            }
        });
    }
    withTypeAhead(debounceInterval = 200) {
        this.typeAheadSubscription = this.letterKeyStream
            .pipe(tap((letter) => this.pressedLetters.push(letter)), debounceTime(debounceInterval), filter(() => this.pressedLetters.length > 0), map(() => this.pressedLetters.join('')))
            .subscribe((inputString) => {
            for (let i = 1; i < this.options.length + 1; i++) {
                const index = (this.activeOptionIndex + i) % this.options.length;
                const option = this.options[index];
                if (option.viewValue.toLowerCase().trim().indexOf(inputString) === 0) {
                    this.setActiveOption(option);
                    break;
                }
            }
            this.pressedLetters = [];
        });
        return this;
    }
    onKeydown(event) {
        switch (event.code) {
            case KeyCodes.TAB:
                this.tabOut.next();
                return;
            case KeyCodes.ARROW_DOWN:
                this.setActiveOptionNext();
                break;
            case KeyCodes.ARROW_UP:
                this.setActiveOptionPrev();
                break;
            default:
                // eslint-disable-next-line no-case-declarations
                let key;
                if (event.key) {
                    key = event.key.toLowerCase();
                }
                else {
                    key = String.fromCharCode(event.keyCode)?.toLowerCase();
                }
                if ((key >= 'a' && key <= 'z') || (key >= '0' && key <= '9')) {
                    this.letterKeyStream.next(key);
                }
                return;
        }
        this.pressedLetters = [];
        event.preventDefault();
    }
    setActiveOption(option) {
        const previousActiveOption = this.activeOption;
        this.activeOption = option;
        this.activeOptionIndex = this.options.indexOf(option);
        if (this.activeOption !== previousActiveOption) {
            previousActiveOption?.setInactive();
            this.activeOption?.setActive();
            this.change.next(this.activeOption);
        }
    }
    setActiveOptionByIndex(index) {
        for (let i = index; i < this.options.length; i++) {
            const option = this.options[i];
            if (!option.isHidden) {
                this.setActiveOption(option);
                break;
            }
        }
    }
    destroy() {
        this.optionsListSubscription.unsubscribe();
        this.typeAheadSubscription?.unsubscribe();
    }
    setActiveOptionPrev() {
        for (let i = this.activeOptionIndex - 1; i >= 0; i--) {
            const option = this.options[i];
            if (!option.isHidden) {
                this.setActiveOption(option);
                break;
            }
        }
    }
    setActiveOptionNext() {
        this.setActiveOptionByIndex(this.activeOptionIndex + 1);
    }
}

let GpuOptionComponent = class GpuOptionComponent {
    get viewValue() {
        return (this.elementRef?.nativeElement?.getElementsByClassName('gpu-option-wrapper')?.[0]?.innerHTML || '').trim();
    }
    get customInputView() {
        return (this.elementRef?.nativeElement?.getElementsByClassName('gpu-custom-input-view')?.[0]?.innerHTML || '').trim();
    }
    get size() {
        return this.formField?.size;
    }
    constructor(elementRef, changeDetectorRef, formField) {
        this.elementRef = elementRef;
        this.changeDetectorRef = changeDetectorRef;
        this.formField = formField;
        this.optionClass = true;
        this.tabIndex = 0;
        // eslint-disable-next-line @angular-eslint/no-output-on-prefix
        this.onSelectionChange = new EventEmitter();
        this.isSelected = false;
        this.isActive = false;
        this.isHidden = false;
        this.formFieldSize = GpuFormFieldSize;
    }
    ngOnInit() {
        this.formField?.sizeChange?.pipe(untilDestroyed(this))?.subscribe(() => this.changeDetectorRef.detectChanges());
    }
    select() {
        this.isSelected = true;
        this.onSelectionChange.emit(this.value);
        this.changeDetectorRef.detectChanges();
    }
    deselect() {
        if (this.isSelected) {
            this.isSelected = false;
        }
        this.changeDetectorRef.detectChanges();
    }
    setActive() {
        if (!this.isActive) {
            this.isActive = true;
            this.changeDetectorRef.detectChanges();
        }
    }
    setInactive() {
        if (this.isActive) {
            this.isActive = false;
            this.changeDetectorRef.detectChanges();
        }
    }
    setVisible() {
        if (this.isHidden) {
            this.isHidden = false;
            this.changeDetectorRef.detectChanges();
        }
    }
    setHidden() {
        if (!this.isHidden) {
            this.isHidden = true;
            this.changeDetectorRef.detectChanges();
        }
    }
    getScrollPosition(panel, panelHeight) {
        const optionOffset = this.elementRef?.nativeElement?.offsetTop;
        const optionHeight = this.elementRef?.nativeElement?.offsetHeight;
        const currentScrollPosition = panel?.nativeElement?.scrollTop;
        if (optionOffset < currentScrollPosition) {
            return optionOffset;
        }
        if (optionOffset + optionHeight > currentScrollPosition + panelHeight) {
            return Math.max(0, optionOffset - panelHeight + optionHeight);
        }
        return currentScrollPosition;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuOptionComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: GPU_FORM_FIELD, host: true, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: GpuOptionComponent, selector: "gpu-option", inputs: { value: "value", resetStyle: "resetStyle" }, outputs: { onSelectionChange: "onSelectionChange" }, host: { properties: { "class.gpu-option": "this.optionClass", "attr.tabIndex": "this.tabIndex" } }, ngImport: i0, template: "<div\n  class=\"gpu-option-wrapper pointer gpx-24\"\n  [ngClass]=\"{\n    'i1-regular gpy-12': size === formFieldSize.Normal,\n    'p4-regular gpy-8': size === formFieldSize.Small,\n    'i1-regular text-secondary': !resetStyle\n  }\"\n  [class.gpu-option-selected]=\"isSelected\"\n  [class.gpu-option-active]=\"isActive\"\n  [class.gpu-option-hidden]=\"isHidden\"\n  (click)=\"select()\"\n>\n  <ng-content></ng-content>\n</div>\n", styles: [".gpu-option{display:block}.gpu-option .gpu-option-wrapper{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.gpu-option .gpu-option-wrapper:hover,.gpu-option .gpu-option-wrapper.gpu-option-active{background:#f9f9fe}.gpu-option .gpu-option-wrapper.gpu-option-selected{background:#efeff4}.gpu-option .gpu-option-wrapper.gpu-option-hidden{display:none}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
GpuOptionComponent = __decorate([
    UntilDestroy()
], GpuOptionComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'gpu-option', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  class=\"gpu-option-wrapper pointer gpx-24\"\n  [ngClass]=\"{\n    'i1-regular gpy-12': size === formFieldSize.Normal,\n    'p4-regular gpy-8': size === formFieldSize.Small,\n    'i1-regular text-secondary': !resetStyle\n  }\"\n  [class.gpu-option-selected]=\"isSelected\"\n  [class.gpu-option-active]=\"isActive\"\n  [class.gpu-option-hidden]=\"isHidden\"\n  (click)=\"select()\"\n>\n  <ng-content></ng-content>\n</div>\n", styles: [".gpu-option{display:block}.gpu-option .gpu-option-wrapper{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.gpu-option .gpu-option-wrapper:hover,.gpu-option .gpu-option-wrapper.gpu-option-active{background:#f9f9fe}.gpu-option .gpu-option-wrapper.gpu-option-selected{background:#efeff4}.gpu-option .gpu-option-wrapper.gpu-option-hidden{display:none}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: GpuFormFieldComponent, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [GPU_FORM_FIELD]
                }, {
                    type: Host
                }] }], propDecorators: { optionClass: [{
                type: HostBinding,
                args: ['class.gpu-option']
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabIndex']
            }], value: [{
                type: Input
            }], resetStyle: [{
                type: Input
            }], onSelectionChange: [{
                type: Output
            }] } });

let GpuSelectComponent = class GpuSelectComponent {
    get value() {
        return this.selectedValue;
    }
    set value(value) {
        if (this.options) {
            this.selectByValue(value, false);
            this.initValue = null;
        }
        else {
            this.initValue = value;
        }
        this.stateChanges.next();
    }
    get readonly() {
        return this.isReadonly;
    }
    set readonly(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isReadonly) {
            return;
        }
        this.isReadonly = coercedValue;
        if (this.isOpen && this.isReadonly) {
            this.close();
        }
        else if (this.focused) {
            this.focused = false;
        }
        this.stateChanges.next();
    }
    get disabled() {
        if (this.ngControl?.disabled != null) {
            return this.ngControl.disabled;
        }
        return this.isDisabled;
    }
    set disabled(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isDisabled) {
            return;
        }
        this.isDisabled = coercedValue;
        if (this.control) {
            this.isDisabled ? this.control.disable() : this.control.enable();
        }
        if (this.isOpen && this.isDisabled) {
            this.close();
        }
        else if (this.focused) {
            this.focused = false;
        }
        this.stateChanges.next();
    }
    get focused() {
        return this.isFocused;
    }
    set focused(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isFocused || (coercedValue && (this.readonly || this.disabled))) {
            return;
        }
        this.isFocused = coercedValue;
        if (this.focused) {
            this.elementRef.nativeElement.focus();
        }
        else {
            this.onTouched();
        }
        this.stateChanges.next();
    }
    get control() {
        return this.ngControl?.control;
    }
    constructor(elementRef, changeDetectorRef, scrollStrategyOptions, document, formField, ngControl, parentForm, parentFormGroup) {
        this.elementRef = elementRef;
        this.changeDetectorRef = changeDetectorRef;
        this.scrollStrategyOptions = scrollStrategyOptions;
        this.document = document;
        this.formField = formField;
        this.ngControl = ngControl;
        this.parentForm = parentForm;
        this.parentFormGroup = parentFormGroup;
        this.selectClass = true;
        this.tabIndex = 0;
        this.selectChanged = new EventEmitter();
        this.scrollStrategy = this.scrollStrategyOptions.reposition();
        this.overlayPositions = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
        this.stateChanges = new Subject();
        this.controlType = GpuFormControlType.Select;
        this.errorState = false;
        this.isOpen = false;
        this.isReadonly = false;
        this.isDisabled = false;
        this.isFocused = false;
        this.isOpenBeforeClick = false;
        this.selectedValue = null;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.onChange = (_) => { };
        this.onTouched = () => { };
        if (ngControl != null) {
            ngControl.valueAccessor = this;
        }
    }
    onFocusChanged(focused) {
        if (this.isOpen) {
            return;
        }
        if (focused) {
            this.open();
        }
        if (focused !== this.focused && (!this.isDisabled || !focused)) {
            this.focused = focused;
        }
    }
    onKeyDown(event) {
        if (this.readonly || this.disabled) {
            return;
        }
        if (this.isOpen) {
            switch (event.code) {
                case KeyCodes.ESCAPE:
                    this.close(false);
                    break;
                case KeyCodes.SPACE:
                case KeyCodes.ENTER:
                    this.keyManager.activeOption?.select();
                    break;
                default:
                    this.keyManager.onKeydown(event);
            }
        }
    }
    ngAfterViewInit() {
        this.keyManager = new KeyManager(this.options).withTypeAhead();
        this.keyManager.change.pipe(untilDestroyed(this)).subscribe((option) => {
            if (this.isOpen) {
                this.scrollToOptionByValue(option?.value);
            }
        });
        this.options.changes.pipe(startWith(null), delay(0), untilDestroyed(this)).subscribe(() => {
            this.resetOptions();
            if (this.initValue) {
                this.value = this.initValue;
                this.initValue = null;
            }
            this.value = this.ngControl ? this.ngControl.value : this.value;
        });
        this.setIsOpenBeforeClick();
        this.getOutsideClickStream()
            .pipe(untilDestroyed(this))
            .subscribe(() => this.close());
        this.keyManager.tabOut.pipe(untilDestroyed(this)).subscribe(() => {
            if (this.isOpen) {
                // Select the active option when tabbing away.
                this.keyManager.activeOption?.select();
                this.close(false);
            }
        });
    }
    ngDoCheck() {
        if (this.control) {
            const parent = this.parentFormGroup || this.parentForm;
            this.errorState = isErrorState(this.control, parent);
            this.stateChanges.next();
        }
    }
    ngOnDestroy() {
        this.keyManager.destroy();
    }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.stateChanges.next();
    }
    onContainerClick() {
        if (!this.isOpen) {
            this.open();
        }
    }
    isEmpty() {
        return this.value == null || this.value?.length === 0;
    }
    hasCustomTrigger() {
        return !!this.customTrigger;
    }
    open() {
        if (this.readonly || this.disabled) {
            return;
        }
        this.isOpen = true;
        if (!this.focused) {
            this.focused = true;
        }
        if (this.isEmpty()) {
            this.keyManager.setActiveOptionByIndex(0);
        }
        else {
            const option = this.options.find((option) => option.value === this.selectedValue);
            this.keyManager.setActiveOption(option);
            this.scrollToOptionByValue(option?.value);
        }
        this.changeDetectorRef.markForCheck();
    }
    close(blur = true) {
        this.isOpen = false;
        if (blur) {
            this.focused = false;
        }
        this.changeDetectorRef.markForCheck();
    }
    selectByValue(value, isUserInput = true) {
        if (value === this.selectedValue) {
            return;
        }
        this.options.find((option) => option.value === this.selectedValue)?.deselect();
        const option = this.options.find((option) => value === option.value);
        this.selectedValue = option?.value;
        this.viewValue = option?.viewValue;
        if (this.selectedValue !== this.control?.value) {
            this.onChange(option?.value);
        }
        this.selectChanged.emit(this.selectedValue);
        if (!isUserInput) {
            option?.select();
        }
        this.changeDetectorRef.detectChanges();
    }
    scrollToOptionByValue(value) {
        setTimeout(() => {
            if (this.panelRef) {
                const scrollTop = this.options
                    .find((option) => option.value === value)
                    ?.getScrollPosition(this.panelRef, MAX_PANEL_HEIGHT);
                this.panelRef.nativeElement.scrollTop = scrollTop;
            }
        });
    }
    getOutsideClickStream() {
        return merge(fromEvent(this.document, 'click'), fromEvent(this.document, 'touch')).pipe(filter((event) => {
            const clickTarget = event.target;
            const formField = this.formField?.containerEltRef?.nativeElement;
            return (this.isOpenBeforeClick &&
                clickTarget !== this.elementRef.nativeElement &&
                (!formField || !formField.contains(clickTarget)) &&
                (!this.panelRef || !this.panelRef?.nativeElement?.contains(clickTarget)));
        }));
    }
    setIsOpenBeforeClick() {
        merge(fromEvent(this.document, 'mousedown'), fromEvent(this.document, 'touchstart'))
            .pipe(untilDestroyed(this))
            .subscribe(() => (this.isOpenBeforeClick = this.isOpen));
    }
    resetOptions() {
        this.optionSelectionChanges = merge(...this.options.map((option) => option.onSelectionChange));
        this.optionSelectionChanges.pipe(takeUntil(this.options.changes), untilDestroyed(this)).subscribe((change) => {
            this.selectByValue(change);
            if (this.isOpen) {
                this.close(false);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuSelectComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1$1.ScrollStrategyOptions }, { token: DOCUMENT, optional: true }, { token: GPU_FORM_FIELD, host: true, optional: true }, { token: i2$1.NgControl, optional: true, self: true }, { token: i2$1.NgForm, optional: true }, { token: i2$1.FormGroupDirective, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: GpuSelectComponent, selector: "gpu-select", inputs: { id: "id", placeholder: "placeholder", value: "value", readonly: "readonly", disabled: "disabled", focused: "focused" }, outputs: { selectChanged: "selectChanged" }, host: { listeners: { "focus": "onFocusChanged(true)", "blur": "onFocusChanged(false)", "keydown": "onKeyDown($event)" }, properties: { "class.gpu-select": "this.selectClass", "attr.tabIndex": "this.tabIndex", "attr.id": "this.id" } }, providers: [{ provide: GpuFormFieldControl, useExisting: GpuSelectComponent }], queries: [{ propertyName: "customTrigger", first: true, predicate: GPU_SELECT_TRIGGER, descendants: true }, { propertyName: "options", predicate: GpuOptionComponent, descendants: true }], viewQueries: [{ propertyName: "panelRef", first: true, predicate: ["panel"], descendants: true }], ngImport: i0, template: "<div class=\"gpu-select-wrapper\" cdk-overlay-origin #origin=\"cdkOverlayOrigin\" #trigger>\n  <div class=\"gpu-select-value\">\n    <span class=\"gpu-placeholder\" *ngIf=\"isEmpty(); else valueTpl\">{{ placeholder }}</span>\n    <ng-template #valueTpl>\n      <ng-container [ngSwitch]=\"hasCustomTrigger()\">\n        <span *ngSwitchCase=\"true\" class=\"gpu-value\">\n          <ng-content select=\"gpu-select-trigger\"></ng-content>\n        </span>\n        <span *ngSwitchDefault class=\"gpu-value\" [innerHTML]=\"viewValue\"></span>\n      </ng-container>\n    </ng-template>\n  </div>\n\n  <div class=\"gpu-select-icon\">\n    <i class=\"gpicon-lg gpicon-down\" [class.rotate]=\"isOpen\"></i>\n  </div>\n</div>\n\n<ng-template\n  cdk-connected-overlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"isOpen\"\n  [cdkConnectedOverlayWidth]=\"trigger.offsetWidth + 32\"\n  [cdkConnectedOverlayScrollStrategy]=\"scrollStrategy\"\n  [cdkConnectedOverlayPositions]=\"overlayPositions\"\n>\n  <div class=\"gpu-select-options-wrapper custom-scroll-parent\">\n    <div class=\"custom-scroll\" #panel>\n      <ng-content select=\"gpu-option\"></ng-content>\n    </div>\n  </div>\n</ng-template>\n", styles: [".gpu-select{outline:0}.gpu-select .gpu-select-wrapper{position:relative}.gpu-select .gpu-select-wrapper .gpu-select-value{height:24px;padding-right:1.75rem;-webkit-user-select:none;user-select:none}.gpu-select .gpu-select-wrapper .gpu-select-value span{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.gpu-select .gpu-select-wrapper .gpu-select-icon{position:absolute;right:-.25rem;top:.5rem;color:#9599aa}.gpu-select .gpu-select-wrapper .gpu-select-icon i{transition:transform .2s linear}.gpu-select .gpu-select-wrapper .gpu-select-icon i.rotate{transform:rotate(-180deg)}.gpu-select-options-wrapper{position:relative;left:-1rem;width:100%;max-height:256px;background:#fff;box-shadow:0 10px 20px 5px #4e5f7c1a;border-radius:12px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "directive", type: i1$1.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush", "cdkConnectedOverlayDisposeOnNavigation"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: i1$1.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
GpuSelectComponent = __decorate([
    UntilDestroy()
], GpuSelectComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'gpu-select', providers: [{ provide: GpuFormFieldControl, useExisting: GpuSelectComponent }], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"gpu-select-wrapper\" cdk-overlay-origin #origin=\"cdkOverlayOrigin\" #trigger>\n  <div class=\"gpu-select-value\">\n    <span class=\"gpu-placeholder\" *ngIf=\"isEmpty(); else valueTpl\">{{ placeholder }}</span>\n    <ng-template #valueTpl>\n      <ng-container [ngSwitch]=\"hasCustomTrigger()\">\n        <span *ngSwitchCase=\"true\" class=\"gpu-value\">\n          <ng-content select=\"gpu-select-trigger\"></ng-content>\n        </span>\n        <span *ngSwitchDefault class=\"gpu-value\" [innerHTML]=\"viewValue\"></span>\n      </ng-container>\n    </ng-template>\n  </div>\n\n  <div class=\"gpu-select-icon\">\n    <i class=\"gpicon-lg gpicon-down\" [class.rotate]=\"isOpen\"></i>\n  </div>\n</div>\n\n<ng-template\n  cdk-connected-overlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"isOpen\"\n  [cdkConnectedOverlayWidth]=\"trigger.offsetWidth + 32\"\n  [cdkConnectedOverlayScrollStrategy]=\"scrollStrategy\"\n  [cdkConnectedOverlayPositions]=\"overlayPositions\"\n>\n  <div class=\"gpu-select-options-wrapper custom-scroll-parent\">\n    <div class=\"custom-scroll\" #panel>\n      <ng-content select=\"gpu-option\"></ng-content>\n    </div>\n  </div>\n</ng-template>\n", styles: [".gpu-select{outline:0}.gpu-select .gpu-select-wrapper{position:relative}.gpu-select .gpu-select-wrapper .gpu-select-value{height:24px;padding-right:1.75rem;-webkit-user-select:none;user-select:none}.gpu-select .gpu-select-wrapper .gpu-select-value span{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.gpu-select .gpu-select-wrapper .gpu-select-icon{position:absolute;right:-.25rem;top:.5rem;color:#9599aa}.gpu-select .gpu-select-wrapper .gpu-select-icon i{transition:transform .2s linear}.gpu-select .gpu-select-wrapper .gpu-select-icon i.rotate{transform:rotate(-180deg)}.gpu-select-options-wrapper{position:relative;left:-1rem;width:100%;max-height:256px;background:#fff;box-shadow:0 10px 20px 5px #4e5f7c1a;border-radius:12px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1$1.ScrollStrategyOptions }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: GpuFormFieldComponent, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [GPU_FORM_FIELD]
                }, {
                    type: Host
                }] }, { type: i2$1.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i2$1.NgForm, decorators: [{
                    type: Optional
                }] }, { type: i2$1.FormGroupDirective, decorators: [{
                    type: Optional
                }] }], propDecorators: { selectClass: [{
                type: HostBinding,
                args: ['class.gpu-select']
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabIndex']
            }], id: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.id']
            }], placeholder: [{
                type: Input
            }], selectChanged: [{
                type: Output
            }], panelRef: [{
                type: ViewChild,
                args: ['panel', { static: false }]
            }], customTrigger: [{
                type: ContentChild,
                args: [GPU_SELECT_TRIGGER]
            }], options: [{
                type: ContentChildren,
                args: [GpuOptionComponent, { descendants: true }]
            }], value: [{
                type: Input
            }], readonly: [{
                type: Input
            }], disabled: [{
                type: Input
            }], focused: [{
                type: Input
            }], onFocusChanged: [{
                type: HostListener,
                args: ['focus', ['true']]
            }, {
                type: HostListener,
                args: ['blur', ['false']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class GpuCustomInputViewDirective {
    constructor() {
        this.elementClass = 'gpu-custom-input-view d-none';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuCustomInputViewDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuCustomInputViewDirective, selector: "gpu-custom-input-view", host: { properties: { "class": "this.elementClass" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuCustomInputViewDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'gpu-custom-input-view',
                }]
        }], propDecorators: { elementClass: [{
                type: HostBinding,
                args: ['class']
            }] } });

let GpuFilterableSelectComponent = class GpuFilterableSelectComponent {
    get value() {
        return this.selectedValue;
    }
    set value(value) {
        if (this.options?.length) {
            this.selectByValue(value);
            this.initValue = null;
        }
        else {
            this.initValue = value;
        }
        this.stateChanges.next();
    }
    get readonly() {
        return this.isReadonly;
    }
    set readonly(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isReadonly) {
            return;
        }
        this.isReadonly = coercedValue;
        if (this.isOpen && this.isReadonly) {
            this.close();
        }
        else if (this.focused) {
            this.focused = false;
        }
        this.stateChanges.next();
    }
    get disabled() {
        if (this.ngControl?.disabled != null) {
            return this.ngControl.disabled;
        }
        return this.isDisabled;
    }
    set disabled(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isDisabled) {
            return;
        }
        this.isDisabled = coercedValue;
        if (this.control) {
            this.isDisabled ? this.control.disable() : this.control.enable();
        }
        if (this.isOpen && this.isDisabled) {
            this.close();
        }
        else if (this.focused) {
            this.focused = false;
        }
        this.stateChanges.next();
    }
    get focused() {
        return this.isFocused;
    }
    set focused(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isFocused || (coercedValue && (this.readonly || this.disabled))) {
            return;
        }
        this.isFocused = coercedValue;
        if (this.focused) {
            this.inputRef.nativeElement.focus();
            this.focus.emit();
        }
        else {
            this.onTouched();
            this.inputRef?.nativeElement?.blur();
            this.blur.emit();
        }
        this.stateChanges.next();
    }
    get control() {
        return this.ngControl?.control;
    }
    get viewValue() {
        return this.inputRef?.nativeElement?.value ?? '';
    }
    constructor(elementRef, changeDetectorRef, scrollStrategyOptions, document, formField, ngControl, parentForm, parentFormGroup) {
        this.elementRef = elementRef;
        this.changeDetectorRef = changeDetectorRef;
        this.scrollStrategyOptions = scrollStrategyOptions;
        this.document = document;
        this.formField = formField;
        this.ngControl = ngControl;
        this.parentForm = parentForm;
        this.parentFormGroup = parentFormGroup;
        this.filterableSelectClass = true;
        this.tabIndex = 0;
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.focus = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.blur = new EventEmitter();
        this.scrollStrategy = this.scrollStrategyOptions.reposition();
        this.overlayPositions = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
        this.stateChanges = new Subject();
        this.controlType = GpuFormControlType.FilterableSelect;
        this.errorState = false;
        this.isOpen = false;
        this.isReadonly = false;
        this.isDisabled = false;
        this.isFocused = false;
        this.isOpenBeforeClick = false;
        this.selectedValue = null;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.onChange = (_) => { };
        this.onTouched = () => { };
        if (ngControl != null) {
            ngControl.valueAccessor = this;
        }
    }
    onFocusChanged(focused) {
        if (this.isOpen) {
            return;
        }
        if (focused) {
            this.open();
        }
        if (focused !== this.focused && (!this.isDisabled || !focused)) {
            this.focused = focused;
        }
    }
    onKeyDown(event) {
        if (this.readonly || this.disabled) {
            return;
        }
        if (this.isOpen) {
            switch (event.code) {
                case KeyCodes.ESCAPE:
                    this.close(false);
                    break;
                case KeyCodes.ENTER:
                    event.preventDefault();
                    // eslint-disable-next-line no-case-declarations
                    const activeOption = this.keyManager.activeOption;
                    if (activeOption && !activeOption.isHidden) {
                        this.selectByValue(this.keyManager.activeOption?.value);
                    }
                    this.close(false);
                    break;
                default:
                    this.keyManager.onKeydown(event);
            }
        }
    }
    ngAfterViewInit() {
        this.keyManager = new KeyManager(this.options);
        this.keyManager.change.pipe(untilDestroyed(this)).subscribe((option) => {
            if (this.isOpen) {
                this.scrollToOptionByValue(option?.value);
            }
        });
        this.options.changes.pipe(startWith(null), delay(0), untilDestroyed(this)).subscribe(() => {
            this.resetOptions();
            if (this.initValue) {
                this.value = this.initValue;
                this.initValue = null;
            }
            this.value = this.ngControl ? this.ngControl.value : this.value;
        });
        this.setIsOpenBeforeClick();
        this.getOutsideClickStream()
            .pipe(untilDestroyed(this))
            .subscribe(() => this.close());
        this.keyManager.tabOut.pipe(untilDestroyed(this)).subscribe(() => {
            if (this.isOpen) {
                // Select the active option when tabbing away.
                this.keyManager.activeOption?.select();
                this.close(false);
            }
        });
    }
    ngDoCheck() {
        if (this.control) {
            const parent = this.parentFormGroup || this.parentForm;
            this.errorState = isErrorState(this.control, parent);
            this.stateChanges.next();
        }
    }
    ngOnDestroy() {
        this.keyManager.destroy();
    }
    hasCustomInputView() {
        return !!this.customInputView;
    }
    writeValue(obj) {
        this.value = obj;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.stateChanges.next();
    }
    onInputChange() {
        if (!this.isOpen) {
            this.open();
        }
        this.updateSelectedValue(null);
        this.filterOptions();
        setTimeout(() => this.overlay?.overlayRef?.updatePosition());
    }
    onContainerClick() {
        if (!this.isOpen) {
            this.open();
        }
    }
    open() {
        if (this.readonly || this.disabled) {
            return;
        }
        this.isOpen = true;
        if (!this.focused) {
            this.focused = true;
        }
        this.filterOptions();
        this.options?.find((option) => option.value === this.selectedValue)?.deselect();
        this.keyManager.setActiveOptionByIndex(0);
        this.inputRef.nativeElement.focus();
        this.changeDetectorRef.markForCheck();
    }
    close(blur = true) {
        this.isOpen = false;
        if (blur) {
            this.focused = false;
        }
        this.changeDetectorRef.markForCheck();
    }
    selectByValue(value) {
        if (value === this.selectedValue) {
            return;
        }
        const option = this.options?.find((option) => value === option.value);
        if (option) {
            this.inputRef.nativeElement.value = this.hasCustomInputView() ? option.customInputView : option.viewValue;
        }
        this.updateSelectedValue(option?.value);
        this.stateChanges.next();
    }
    updateSelectedValue(value) {
        this.selectedValue = value;
        this.onChange(value);
    }
    scrollToOptionByValue(value) {
        setTimeout(() => {
            if (this.panelRef) {
                const scrollTop = this.options
                    ?.find((option) => option.value === value)
                    ?.getScrollPosition(this.panelRef, MAX_PANEL_HEIGHT);
                this.panelRef.nativeElement.scrollTop = scrollTop;
            }
        });
    }
    getOutsideClickStream() {
        return merge(fromEvent(this.document, 'click'), fromEvent(this.document, 'touch')).pipe(filter((event) => {
            const clickTarget = event.target;
            const formField = this.formField?.containerEltRef?.nativeElement;
            return (this.isOpenBeforeClick &&
                clickTarget !== this.elementRef.nativeElement &&
                (!formField || !formField.contains(clickTarget)) &&
                (!this.panelRef || !this.panelRef?.nativeElement?.contains(clickTarget)));
        }));
    }
    setIsOpenBeforeClick() {
        merge(fromEvent(this.document, 'mousedown'), fromEvent(this.document, 'touchstart'))
            .pipe(untilDestroyed(this))
            .subscribe(() => (this.isOpenBeforeClick = this.isOpen));
    }
    filterOptions() {
        const inputValue = this.inputRef?.nativeElement?.value ?? '';
        this.options?.toArray()?.map((option) => {
            option.viewValue.toLowerCase().includes(inputValue.toLowerCase()) ? option.setVisible() : option.setHidden();
        });
        this.keyManager.setActiveOptionByIndex(0);
    }
    resetOptions() {
        this.optionSelectionChanges = merge(...this.options.map((option) => option.onSelectionChange));
        this.optionSelectionChanges.pipe(takeUntil(this.options.changes), untilDestroyed(this)).subscribe((change) => {
            this.selectByValue(change);
            if (this.isOpen) {
                this.close(false);
            }
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuFilterableSelectComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1$1.ScrollStrategyOptions }, { token: DOCUMENT, optional: true }, { token: GPU_FORM_FIELD, host: true, optional: true }, { token: i2$1.NgControl, optional: true, self: true }, { token: i2$1.NgForm, optional: true }, { token: i2$1.FormGroupDirective, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: GpuFilterableSelectComponent, selector: "gpu-filterable-select", inputs: { id: "id", placeholder: "placeholder", value: "value", readonly: "readonly", disabled: "disabled", focused: "focused" }, outputs: { focus: "focus", blur: "blur" }, host: { listeners: { "focus": "onFocusChanged(true)", "blur": "onFocusChanged(false)", "keydown": "onKeyDown($event)" }, properties: { "class.gpu-filterable-select": "this.filterableSelectClass", "attr.tabIndex": "this.tabIndex", "attr.id": "this.id" } }, providers: [{ provide: GpuFormFieldControl, useExisting: GpuFilterableSelectComponent }], queries: [{ propertyName: "customInputView", first: true, predicate: GpuCustomInputViewDirective, descendants: true }, { propertyName: "options", predicate: GpuOptionComponent, descendants: true }], viewQueries: [{ propertyName: "inputRef", first: true, predicate: ["input"], descendants: true }, { propertyName: "panelRef", first: true, predicate: ["panel"], descendants: true }, { propertyName: "overlay", first: true, predicate: ["overlay"], descendants: true }], ngImport: i0, template: "<div class=\"gpu-filterable-select-wrapper\" cdk-overlay-origin #origin=\"cdkOverlayOrigin\" #trigger>\n  <input\n    #input\n    class=\"gpu-input\"\n    type=\"text\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    [attr.placeholder]=\"placeholder\"\n    (input)=\"onInputChange()\"\n    autocomplete=\"new-password\"\n    (blur)=\"onFocusChanged(false)\"\n    tabindex=\"-1\"\n  />\n\n  <div class=\"gpu-filterable-select-icon\">\n    <i class=\"gpicon-lg gpicon-down\" [class.rotate]=\"isOpen\"></i>\n  </div>\n</div>\n\n<ng-template\n  #overlay=\"cdkConnectedOverlay\"\n  cdk-connected-overlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"isOpen\"\n  [cdkConnectedOverlayWidth]=\"trigger.offsetWidth + 32\"\n  [cdkConnectedOverlayScrollStrategy]=\"scrollStrategy\"\n  [cdkConnectedOverlayPositions]=\"overlayPositions\"\n>\n  <div class=\"gpu-filterable-select-options-wrapper custom-scroll-parent\">\n    <div class=\"custom-scroll\" #panel>\n      <ng-content select=\"gpu-option\"></ng-content>\n    </div>\n  </div>\n</ng-template>\n", styles: [".gpu-filterable-select{outline:0}.gpu-filterable-select .gpu-filterable-select-wrapper{position:relative}.gpu-filterable-select .gpu-filterable-select-wrapper .gpu-input{padding-right:1.75rem}.gpu-filterable-select .gpu-filterable-select-wrapper .gpu-filterable-select-icon{position:absolute;right:-.25rem;top:.5rem;color:#9599aa}.gpu-filterable-select .gpu-filterable-select-wrapper .gpu-filterable-select-icon i{transition:transform .2s linear}.gpu-filterable-select .gpu-filterable-select-wrapper .gpu-filterable-select-icon i.rotate{transform:rotate(-180deg)}.gpu-filterable-select-options-wrapper{position:relative;left:-1rem;width:100%;max-height:256px;background:#fff;box-shadow:0 10px 20px 5px #4e5f7c1a;border-radius:12px}\n"], dependencies: [{ kind: "directive", type: i1$1.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush", "cdkConnectedOverlayDisposeOnNavigation"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: i1$1.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
};
GpuFilterableSelectComponent = __decorate([
    UntilDestroy()
], GpuFilterableSelectComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuFilterableSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'gpu-filterable-select', providers: [{ provide: GpuFormFieldControl, useExisting: GpuFilterableSelectComponent }], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"gpu-filterable-select-wrapper\" cdk-overlay-origin #origin=\"cdkOverlayOrigin\" #trigger>\n  <input\n    #input\n    class=\"gpu-input\"\n    type=\"text\"\n    [disabled]=\"disabled\"\n    [readonly]=\"readonly\"\n    [attr.placeholder]=\"placeholder\"\n    (input)=\"onInputChange()\"\n    autocomplete=\"new-password\"\n    (blur)=\"onFocusChanged(false)\"\n    tabindex=\"-1\"\n  />\n\n  <div class=\"gpu-filterable-select-icon\">\n    <i class=\"gpicon-lg gpicon-down\" [class.rotate]=\"isOpen\"></i>\n  </div>\n</div>\n\n<ng-template\n  #overlay=\"cdkConnectedOverlay\"\n  cdk-connected-overlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"isOpen\"\n  [cdkConnectedOverlayWidth]=\"trigger.offsetWidth + 32\"\n  [cdkConnectedOverlayScrollStrategy]=\"scrollStrategy\"\n  [cdkConnectedOverlayPositions]=\"overlayPositions\"\n>\n  <div class=\"gpu-filterable-select-options-wrapper custom-scroll-parent\">\n    <div class=\"custom-scroll\" #panel>\n      <ng-content select=\"gpu-option\"></ng-content>\n    </div>\n  </div>\n</ng-template>\n", styles: [".gpu-filterable-select{outline:0}.gpu-filterable-select .gpu-filterable-select-wrapper{position:relative}.gpu-filterable-select .gpu-filterable-select-wrapper .gpu-input{padding-right:1.75rem}.gpu-filterable-select .gpu-filterable-select-wrapper .gpu-filterable-select-icon{position:absolute;right:-.25rem;top:.5rem;color:#9599aa}.gpu-filterable-select .gpu-filterable-select-wrapper .gpu-filterable-select-icon i{transition:transform .2s linear}.gpu-filterable-select .gpu-filterable-select-wrapper .gpu-filterable-select-icon i.rotate{transform:rotate(-180deg)}.gpu-filterable-select-options-wrapper{position:relative;left:-1rem;width:100%;max-height:256px;background:#fff;box-shadow:0 10px 20px 5px #4e5f7c1a;border-radius:12px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1$1.ScrollStrategyOptions }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: GpuFormFieldComponent, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [GPU_FORM_FIELD]
                }, {
                    type: Host
                }] }, { type: i2$1.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i2$1.NgForm, decorators: [{
                    type: Optional
                }] }, { type: i2$1.FormGroupDirective, decorators: [{
                    type: Optional
                }] }], propDecorators: { filterableSelectClass: [{
                type: HostBinding,
                args: ['class.gpu-filterable-select']
            }], tabIndex: [{
                type: HostBinding,
                args: ['attr.tabIndex']
            }], id: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.id']
            }], placeholder: [{
                type: Input
            }], customInputView: [{
                type: ContentChild,
                args: [GpuCustomInputViewDirective]
            }], focus: [{
                type: Output
            }], blur: [{
                type: Output
            }], inputRef: [{
                type: ViewChild,
                args: ['input']
            }], panelRef: [{
                type: ViewChild,
                args: ['panel', { static: false }]
            }], overlay: [{
                type: ViewChild,
                args: ['overlay']
            }], options: [{
                type: ContentChildren,
                args: [GpuOptionComponent, { descendants: true }]
            }], value: [{
                type: Input
            }], readonly: [{
                type: Input
            }], disabled: [{
                type: Input
            }], focused: [{
                type: Input
            }], onFocusChanged: [{
                type: HostListener,
                args: ['focus', ['true']]
            }, {
                type: HostListener,
                args: ['blur', ['false']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class GpuLocalNumberDirective {
    get gpuLocalNumber() {
        return this.isLocalNumber;
    }
    set gpuLocalNumber(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isLocalNumber) {
            return;
        }
        this.isLocalNumber = coercedValue;
        this.inputMode = this.isLocalNumber ? 'decimal' : null;
        this.updateOnChangeFn();
    }
    constructor(elementRef, translate) {
        this.elementRef = elementRef;
        this.translate = translate;
        this.isLocalNumber = false;
        this.decimalSeparators = /[,.]/;
        this.notAllowedCharacters = /[^\d.,]/g;
    }
    onKeyDown(event) {
        if (this.gpuLocalNumber &&
            new RegExp(this.decimalSeparators).test(event.key) &&
            this.elementRef.nativeElement.value.match(this.decimalSeparators)) {
            event.preventDefault();
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChangeLocalNumber(fn) {
        return (value) => {
            let newValue = this.getMatchedLocalNumber(value);
            this.elementRef.nativeElement.value = newValue;
            newValue = newValue?.replace(this.decimalSeparators, '.');
            fn(newValue && newValue !== '.' ? Number(newValue).toString() : '');
        };
    }
    getMatchedLocalNumber(value) {
        const matchedNumbers = value
            ?.toString()
            .replace(this.notAllowedCharacters, '')
            .match(/^\d*((\.|,)\d*)?/g);
        if (!matchedNumbers?.length) {
            return '';
        }
        return matchedNumbers[0]?.replace(this.decimalSeparators, getLocaleNumberSymbol(this.translate.currentLang ?? 'en', NumberSymbol.Decimal));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuLocalNumberDirective, deps: [{ token: i0.ElementRef }, { token: i1$2.TranslateService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuLocalNumberDirective, inputs: { gpuLocalNumber: "gpuLocalNumber" }, host: { listeners: { "keydown": "onKeyDown($event)" }, properties: { "attr.inputMode": "this.inputMode" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuLocalNumberDirective, decorators: [{
            type: Directive
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.TranslateService }], propDecorators: { gpuLocalNumber: [{
                type: Input
            }], inputMode: [{
                type: HostBinding,
                args: ['attr.inputMode']
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

/* eslint-disable @typescript-eslint/no-explicit-any */
class GpuInputDirective extends GpuLocalNumberDirective {
    get value() {
        return this.inputValueAccessor.value;
    }
    set value(value) {
        if (value !== this.value) {
            this.inputValueAccessor.value = value;
            this.onChange(value);
            this.stateChanges.next();
        }
    }
    get readonly() {
        return this.isReadonly;
    }
    set readonly(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isReadonly) {
            return;
        }
        this.isReadonly = coercedValue;
        if (this.focused) {
            this.focused = false;
        }
        this.stateChanges.next();
    }
    get disabled() {
        if (this.ngControl?.disabled != null) {
            return this.ngControl.disabled;
        }
        return this.isDisabled;
    }
    set disabled(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isDisabled) {
            return;
        }
        this.isDisabled = coercedValue;
        if (this.control) {
            this.isDisabled ? this.control.disable() : this.control.enable();
        }
        if (this.focused) {
            this.focused = false;
        }
        this.stateChanges.next();
    }
    get focused() {
        return this.isFocused;
    }
    set focused(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isFocused || (coercedValue && (this.readonly || this.disabled))) {
            return;
        }
        this.isFocused = coercedValue;
        if (this.focused) {
            this.elementRef.nativeElement.focus();
        }
        else {
            this.onTouched();
        }
        this.stateChanges.next();
    }
    get control() {
        return this.ngControl?.control;
    }
    constructor(elementRef, translate, cdRef, ngControl, parentForm, parentFormGroup) {
        super(elementRef, translate);
        this.elementRef = elementRef;
        this.translate = translate;
        this.cdRef = cdRef;
        this.ngControl = ngControl;
        this.parentForm = parentForm;
        this.parentFormGroup = parentFormGroup;
        this.inputClass = true;
        this.stateChanges = new Subject();
        this.controlType = GpuFormControlType.Input;
        this.errorState = false;
        this.autofilled = false;
        this.isReadonly = false;
        this.isDisabled = false;
        this.isFocused = false;
        this.inputValueAccessor = this.elementRef.nativeElement;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.pureOnChange = (_) => { };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.onChange = (_) => { };
        this.onTouched = () => { };
        if (ngControl != null) {
            ngControl.valueAccessor = this;
        }
    }
    onInput(value) {
        this.value = value;
    }
    onFocusChanged(focused) {
        if (focused !== this.focused && (!this.readonly || !focused)) {
            this.focused = focused;
        }
    }
    ngOnInit() {
        if (this.control) {
            this.inputValueAccessor = this.control;
        }
    }
    ngAfterViewInit() {
        const element = this.elementRef.nativeElement;
        this.autofillAnimationListener = (event) => {
            if (event.animationName === INPUT_AUTOFILL_START_CLASS && !element.classList.contains(INPUT_AUTOFILLED_CLASS)) {
                element.classList.add(INPUT_AUTOFILLED_CLASS);
                this.autofilled = true;
                this.stateChanges.next();
            }
            else if (event.animationName === INPUT_AUTOFILL_END_CLASS &&
                element.classList.contains(INPUT_AUTOFILLED_CLASS)) {
                element.classList.remove(INPUT_AUTOFILLED_CLASS);
                this.autofilled = false;
                this.stateChanges.next();
            }
        };
        element.addEventListener('animationstart', this.autofillAnimationListener);
    }
    ngDoCheck() {
        if (this.control) {
            const parent = this.parentFormGroup || this.parentForm;
            this.errorState = isErrorState(this.control, parent);
            this.stateChanges.next();
        }
    }
    ngOnDestroy() {
        this.elementRef.nativeElement.removeEventListener('animationstart', this.autofillAnimationListener);
    }
    writeValue(obj) {
        setTimeout(() => {
            this.elementRef.nativeElement.value = this.gpuLocalNumber ? this.getMatchedLocalNumber(obj) : obj;
            this.cdRef.markForCheck();
        });
    }
    registerOnChange(fn) {
        this.pureOnChange = fn;
        this.updateOnChangeFn();
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        if (isDisabled !== this.disabled) {
            this.disabled = isDisabled;
        }
    }
    onContainerClick() {
        if (!this.focused) {
            this.focused = true;
        }
    }
    updateBoxShadowColor(color) {
        setTimeout(() => {
            this.boxShadow = `0 0 0 12px inset ${color}`;
        });
    }
    updateOnChangeFn() {
        this.onChange = this.gpuLocalNumber ? this.onChangeLocalNumber(this.pureOnChange) : this.pureOnChange;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuInputDirective, deps: [{ token: i0.ElementRef }, { token: i1$2.TranslateService }, { token: i0.ChangeDetectorRef }, { token: i2$1.NgControl, optional: true, self: true }, { token: i2$1.NgForm, optional: true }, { token: i2$1.FormGroupDirective, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuInputDirective, selector: "[gpuInput]", inputs: { id: "id", placeholder: "placeholder", value: "value", readonly: "readonly", disabled: "disabled", focused: "focused" }, host: { listeners: { "input": "onInput($event.target.value)", "focus": "onFocusChanged(true)", "blur": "onFocusChanged(false)" }, properties: { "class.gpu-input": "this.inputClass", "style.boxShadow": "this.boxShadow", "attr.id": "this.id", "attr.placeholder": "this.placeholder", "readonly": "this.readonly", "disabled": "this.disabled" } }, providers: [{ provide: GpuFormFieldControl, useExisting: GpuInputDirective }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[gpuInput]',
                    providers: [{ provide: GpuFormFieldControl, useExisting: GpuInputDirective }],
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.TranslateService }, { type: i0.ChangeDetectorRef }, { type: i2$1.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i2$1.NgForm, decorators: [{
                    type: Optional
                }] }, { type: i2$1.FormGroupDirective, decorators: [{
                    type: Optional
                }] }], propDecorators: { inputClass: [{
                type: HostBinding,
                args: ['class.gpu-input']
            }], boxShadow: [{
                type: HostBinding,
                args: ['style.boxShadow']
            }], id: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.id']
            }], placeholder: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.placeholder']
            }], value: [{
                type: Input
            }], readonly: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['readonly']
            }], disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['disabled']
            }], focused: [{
                type: Input
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event.target.value']]
            }], onFocusChanged: [{
                type: HostListener,
                args: ['focus', ['true']]
            }, {
                type: HostListener,
                args: ['blur', ['false']]
            }] } });

class GpuNgbDateParserFormatter extends NgbDateParserFormatter {
    constructor(localDatePipe) {
        super();
        this.localDatePipe = localDatePipe;
    }
    parse() {
        return null;
    }
    format(date) {
        return this.localDatePipe.transform(date)?.toString() ?? '';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuNgbDateParserFormatter, deps: [{ token: i1$3.GpuLocalDatePipe }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuNgbDateParserFormatter }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuNgbDateParserFormatter, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: i1$3.GpuLocalDatePipe }] });

let GpuDatepickerDirective = class GpuDatepickerDirective {
    get value() {
        return this.inputValueAccessor.value;
    }
    set value(value) {
        if (!this.value) {
            this.initValue = value;
        }
        if (value !== this.value) {
            if (!this.datepicker || this.control) {
                this.inputValueAccessor.value = value;
                this.onChange(value);
            }
            if (this.datepicker) {
                this.writeValue(value);
            }
            this.stateChanges.next();
        }
    }
    get disabled() {
        if (this.ngControl?.disabled != null) {
            return this.ngControl.disabled;
        }
        return this.isDisabled;
    }
    set disabled(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isDisabled) {
            return;
        }
        this.isDisabled = coercedValue;
        if (this.control) {
            this.isDisabled ? this.control.disable() : this.control.enable();
        }
        if (this.datepicker?.isOpen() && this.isDisabled) {
            this.datepicker.close();
        }
        else if (this.focused) {
            this.focused = false;
        }
        this.stateChanges.next();
    }
    get focused() {
        return this.isFocused;
    }
    set focused(value) {
        const coercedValue = coerceBooleanProperty(value);
        if (coercedValue === this.isFocused || (coercedValue && this.disabled)) {
            return;
        }
        this.isFocused = coercedValue;
        if (!this.focused) {
            this.onTouched();
        }
        this.stateChanges.next();
    }
    get control() {
        return this.ngControl?.control;
    }
    constructor(elementRef, localDate, ngControl, parentForm, parentFormGroup, formField, document) {
        this.elementRef = elementRef;
        this.localDate = localDate;
        this.ngControl = ngControl;
        this.parentForm = parentForm;
        this.parentFormGroup = parentFormGroup;
        this.formField = formField;
        this.document = document;
        this.inputClass = true;
        this.datepickerClass = true;
        this.readonly = true;
        this.stateChanges = new Subject();
        this.controlType = GpuFormControlType.Datepicker;
        this.isDisabled = false;
        this.isFocused = false;
        this.ignoreDatepickerSelectClick = false;
        this.inputValueAccessor = this.elementRef.nativeElement;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.onChange = (_) => { };
        this.onTouched = () => { };
        if (ngControl != null) {
            ngControl.valueAccessor = this;
        }
    }
    onFocusChanged(focused) {
        if (this.datepicker?.isOpen()) {
            this.focused = true;
            return;
        }
        if (focused !== this.focused) {
            this.focused = focused;
        }
    }
    ngOnInit() {
        if (this.control) {
            this.inputValueAccessor = this.control;
        }
        if (this.datepicker) {
            if (!this.control) {
                this.value = this.initValue;
            }
            this.stateChanges.next();
            this.datepicker.dateSelect.pipe(untilDestroyed(this)).subscribe((date) => {
                this.value = date;
                this.ignoreDatepickerSelectClick = true;
                setTimeout(() => (this.ignoreDatepickerSelectClick = false));
            });
            this.getOutsideClickStream().subscribe(() => (this.focused = false));
        }
    }
    ngDoCheck() {
        if (this.control) {
            const parent = this.parentFormGroup || this.parentForm;
            this.errorState = isErrorState(this.control, parent);
            this.stateChanges.next();
        }
    }
    writeValue(obj) {
        setTimeout(() => {
            this.elementRef.nativeElement.value = this.localDate.transform(obj) ?? '';
        });
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        if (isDisabled !== this.disabled) {
            this.disabled = isDisabled;
        }
    }
    onContainerClick(event) {
        if (!this.focused) {
            this.focused = true;
        }
        const clickTarget = event.target;
        if (this.datepicker?.isOpen() && this.elementRef.nativeElement.contains(clickTarget)) {
            this.datepicker?.close();
        }
        else if (!this.datepicker?.isOpen() && !this.ignoreDatepickerSelectClick) {
            setTimeout(() => {
                this.datepicker.open();
                const datepickerBody = document.querySelector('ngb-datepicker.ngb-dp-body');
                if (this.datepicker.container === 'body' && datepickerBody) {
                    datepickerBody.style.width = this.formField?.containerEltRef?.nativeElement?.offsetWidth + 'px';
                    datepickerBody.classList.add('form-field-datepicker');
                }
            });
        }
    }
    getOutsideClickStream() {
        return merge(fromEvent(this.document, 'click'), fromEvent(this.document, 'touchend')).pipe(filter((event) => {
            const clickTarget = event.target;
            return this.datepicker?.isOpen() && !this.formField?.containerEltRef?.nativeElement?.contains(clickTarget);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuDatepickerDirective, deps: [{ token: i0.ElementRef }, { token: i1$3.GpuLocalDatePipe }, { token: i2$1.NgControl, optional: true, self: true }, { token: i2$1.NgForm, optional: true }, { token: i2$1.FormGroupDirective, optional: true }, { token: GPU_FORM_FIELD, host: true, optional: true }, { token: DOCUMENT, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuDatepickerDirective, selector: "input[gpuDatepicker]", inputs: { id: "id", placeholder: "placeholder", datepicker: "datepicker", value: "value", disabled: "disabled", focused: "focused" }, host: { listeners: { "focus": "onFocusChanged(true)", "blur": "onFocusChanged(false)" }, properties: { "class.gpu-input": "this.inputClass", "class.gpu-datepicker": "this.datepickerClass", "readonly": "this.readonly", "attr.id": "this.id", "attr.placeholder": "this.placeholder", "disabled": "this.disabled" } }, providers: [
            { provide: GpuFormFieldControl, useExisting: GpuDatepickerDirective },
            { provide: NgbDateParserFormatter, useClass: GpuNgbDateParserFormatter },
        ], exportAs: ["gpuDatepicker"], ngImport: i0 }); }
};
GpuDatepickerDirective = __decorate([
    UntilDestroy()
], GpuDatepickerDirective);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuDatepickerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[gpuDatepicker]',
                    exportAs: 'gpuDatepicker',
                    providers: [
                        { provide: GpuFormFieldControl, useExisting: GpuDatepickerDirective },
                        { provide: NgbDateParserFormatter, useClass: GpuNgbDateParserFormatter },
                    ],
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$3.GpuLocalDatePipe }, { type: i2$1.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i2$1.NgForm, decorators: [{
                    type: Optional
                }] }, { type: i2$1.FormGroupDirective, decorators: [{
                    type: Optional
                }] }, { type: GpuFormFieldComponent, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [GPU_FORM_FIELD]
                }, {
                    type: Host
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { inputClass: [{
                type: HostBinding,
                args: ['class.gpu-input']
            }], datepickerClass: [{
                type: HostBinding,
                args: ['class.gpu-datepicker']
            }], readonly: [{
                type: HostBinding,
                args: ['readonly']
            }], id: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.id']
            }], placeholder: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.placeholder']
            }], datepicker: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['disabled']
            }], focused: [{
                type: Input
            }], onFocusChanged: [{
                type: HostListener,
                args: ['focus', ['true']]
            }, {
                type: HostListener,
                args: ['blur', ['false']]
            }] } });

class GpuSelectTriggerDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuSelectTriggerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: GpuSelectTriggerDirective, selector: "gpu-select-trigger", providers: [{ provide: GPU_SELECT_TRIGGER, useExisting: GpuSelectTriggerDirective }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuSelectTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'gpu-select-trigger',
                    providers: [{ provide: GPU_SELECT_TRIGGER, useExisting: GpuSelectTriggerDirective }],
                }]
        }] });

class GpuFormFieldModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuFormFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: GpuFormFieldModule, declarations: [GpuFormFieldComponent,
            GpuSelectComponent,
            GpuOptionComponent,
            GpuFilterableSelectComponent,
            GpuErrorDirective,
            GpuHintDirective,
            GpuInputDirective,
            GpuLabelDirective,
            GpuPrefixDirective,
            GpuPreSuffixDirective,
            GpuSuffixDirective,
            GpuDatepickerDirective,
            GpuSelectTriggerDirective,
            GpuCustomInputViewDirective], imports: [CommonModule, TranslateModule, OverlayModule, ObserversModule, NgbDatepickerModule, GpuSharedModule], exports: [GpuFormFieldComponent,
            GpuSelectComponent,
            GpuOptionComponent,
            GpuFilterableSelectComponent,
            GpuErrorDirective,
            GpuHintDirective,
            GpuInputDirective,
            GpuLabelDirective,
            GpuPrefixDirective,
            GpuPreSuffixDirective,
            GpuSuffixDirective,
            GpuDatepickerDirective,
            GpuSelectTriggerDirective,
            GpuCustomInputViewDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuFormFieldModule, imports: [CommonModule, TranslateModule, OverlayModule, ObserversModule, NgbDatepickerModule, GpuSharedModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GpuFormFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        GpuFormFieldComponent,
                        GpuSelectComponent,
                        GpuOptionComponent,
                        GpuFilterableSelectComponent,
                        GpuErrorDirective,
                        GpuHintDirective,
                        GpuInputDirective,
                        GpuLabelDirective,
                        GpuPrefixDirective,
                        GpuPreSuffixDirective,
                        GpuSuffixDirective,
                        GpuDatepickerDirective,
                        GpuSelectTriggerDirective,
                        GpuCustomInputViewDirective,
                    ],
                    imports: [CommonModule, TranslateModule, OverlayModule, ObserversModule, NgbDatepickerModule, GpuSharedModule],
                    exports: [
                        GpuFormFieldComponent,
                        GpuSelectComponent,
                        GpuOptionComponent,
                        GpuFilterableSelectComponent,
                        GpuErrorDirective,
                        GpuHintDirective,
                        GpuInputDirective,
                        GpuLabelDirective,
                        GpuPrefixDirective,
                        GpuPreSuffixDirective,
                        GpuSuffixDirective,
                        GpuDatepickerDirective,
                        GpuSelectTriggerDirective,
                        GpuCustomInputViewDirective,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { GpuCustomInputViewDirective, GpuDatepickerDirective, GpuErrorDirective, GpuFilterableSelectComponent, GpuFormFieldAppearance, GpuFormFieldComponent, GpuFormFieldModule, GpuFormFieldSize, GpuHintDirective, GpuInputDirective, GpuLabelDirective, GpuLocalNumberDirective, GpuOptionComponent, GpuPreSuffixDirective, GpuPrefixDirective, GpuSelectComponent, GpuSelectTriggerDirective, GpuSuffixDirective };
